import React, {SyntheticEvent, useEffect, useState} from "react";
import {Link as RouterLink, useHistory, useParams} from "react-router-dom";

// Logic.
import {useDispatch} from "react-redux";

// Design.
import {
    BaseCrudClient,
    Spinner,
    GenericFormContainer,
    enumNamesToSelect,
    Grid,
    Leap4Breadcrumbs,
    Mode,
    MuiIcons,
    Typography,
    Button,
    Toc as TocIcon,
    Create as CreateIcon,
    GpsFixed as GpsFixedIcon
} from "@leap4/frontend";
import { styles } from "./style";
import {
    AdServerEnum,
    IAdServer
} from "@leap4/entities-discrepancy-common";
import {baseBackendRoute} from "../../../../config/generals";
import {urlService} from "../../../routing/urlsService";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../../shared/OneOrgOnly/OneOrgOnly";

const {AutoFixNormal: AutoFixNormalIcon} = MuiIcons;


const {add, update, deleteInstance, getById} = BaseCrudClient;

interface IFormData extends Partial<IAdServer> {
}

const AdServersSelect = enumNamesToSelect(AdServerEnum);


const AddEditAdServer = (): JSX.Element => {
    const history = useHistory();
    const params = useParams<{ id?: string }>();
    const dispatch = useDispatch();

    const schemaName = "ad-server";
    const addInstanceRoute = `/${schemaName}s/add`;
    const editInstanceRoute = `/${schemaName}s/`;

    const [isAddPage, setIsAddPage] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(true);


    const [entity, setInstance] = useState<IFormData>({});


    const handleFormChange = (e: any) => {
        let {name, value} = e.target;
        setInstance({...entity, [name]: value});
    }


    const handleSubmit = async (ev: SyntheticEvent) => {
        // For block rendering.
        ev?.preventDefault();
        setIsLoading(true)
        if (!entity) {
            return;
        }


        if (isAddPage) {
            //TODO: Replace with dto type instead of any.
            await add<any>(entity, schemaName, history, dispatch, baseBackendRoute);
        } else if (params.id && params.id != "add") {
            //TODO: Replace with dto type instead of any.
            await update<any>(params.id, entity, schemaName, history, dispatch, baseBackendRoute);
        }

        setIsLoading(false)
    };

    // Init form.
    useEffect(() => {
        (async () => {
            setIsLoading(true);

            const id = params.id;

            // For edit page.
            if (id && id !== "add") {
                setIsAddPage(false);
                const instanceData = await getById(id, schemaName, dispatch, baseBackendRoute);
                setInstance({...instanceData});
            } else {
                setInstance({
                    name: "",
                })
            }

            setIsLoading(false);
        })()
    }, []);

    const deleteFunc = async () => {
        setIsLoading(true)
        await deleteInstance(String(params.id), schemaName, history, dispatch, baseBackendRoute)
        setIsLoading(false);
    }

    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }

    return (
        <>
            <Leap4Breadcrumbs
                breadcrumbs={[
                    {
                        text: "AdServers Dashboard",
                        icon: <TocIcon/>,
                        link: urlService.adServers()
                    },
                    {
                        text: isAddPage ? "Create" : "Update",
                        link: isAddPage ? addInstanceRoute : editInstanceRoute,
                        icon: isAddPage ? <CreateIcon/> : <AutoFixNormalIcon/>
                    },
                    {
                        text: entity.name,
                        link: "",
                        icon: <GpsFixedIcon/>
                    }
                ]}
            />
            <GenericFormContainer mode={isAddPage ? Mode.Create : Mode.Edit} onCreateOrEditFunc={handleSubmit}
                                  disabled={isLoading}
                                  style={{height: '300px', padding: '20px', margin: "35px 25px", borderRadius: "16px"}}
                                  onDeleteFunction={deleteFunc}>


                {isLoading ? <Spinner/> :
                    <form style={styles.form} noValidate onSubmit={handleSubmit}>
                        <Grid container direction={"column"} alignItems={"flex-start"}>
                            <Grid container justifyContent={"space-between"} spacing={{lg: 3, xs: 1}}>
                                <Grid item>
                                    <Typography variant="h5" fontFamily={"Quicksand"} fontWeight={600}>
                                        Ad Server Info
                                    </Typography>
                                </Grid>
                                {params.id && <Grid item>
                                    <RouterLink to={urlService.adServerOverview(params.id, true)}>
                                        <Button size="large" variant="contained" color="primary">
                                            TO OVERVIEW
                                        </Button>
                                    </RouterLink>
                                </Grid>}
                            </Grid>
                            <Grid item width={"60%"}>
                                <AdServersSelect
                                    required
                                    fullWidth
                                    value={entity?.name}
                                    onChange={handleFormChange}
                                    name="name"/>
                            </Grid>

                        </Grid>
                    </form>}
            </GenericFormContainer>


        </>
    );
}


export default AddEditAdServer;
